<template>
  <div class="pay-order-content" v-show="show" v-loading="loading">
    <rt-card :title="''">
<!--      <i @click="cancel" class="el-icon-close" />-->
      <div class="pay-order-main">
        <template>
          <div class="pay-order-btn-group">
            <el-button type="primary" plain size="mini" @click="getOrder(orderData)">刷新</el-button>
            <el-button type="primary" size="mini" @click="handleShowList(orderData.plateNumber)">查找记录</el-button>
            <el-button type="primary" size="mini" @click="handleShowPlateNum(orderData.plateNumber)">修改车牌</el-button>
            <el-button
              type="text"
              class="btn-radio"
              :disabled="orderData.isPaid || orderData.leftAt !== ''"
              @click="handleReport">
              <el-image :src="require('@/assets/img/radiod02@2x.png')" alt="" style="width: 15px;" v-if="orderData.isPaid || orderData.leftAt !== ''"></el-image>
              <el-image :src="require('@/assets/img/radio02@2x.png')" alt="" style="width: 15px;" v-else></el-image>
            </el-button>
          </div>
          <div class="pay-amount-item plate" :style="{fontSize: bulletPlateSizeOptions[settingConfig.BulletPlateSize], color: bulletPlateColorOptions[settingConfig.BulletPlateColor]}">
            {{ orderData.plateNumber }}
            <b v-if="orderData.parkingLength !== ''">{{
              "(" + orderData.parkingLength + ")"
              }}</b>
            <el-tag :type="titleObj.type" v-if="orderData.id !== -1">{{titleObj.value}}</el-tag>
            <el-tag type="info" v-else>暂无记录</el-tag>
          </div>
          <ul>
            <li>
              <p style="display: flex; align-items: center;">
                <span>入场时间：</span>
                <span v-if="orderData.cameAt === ''">
                <el-date-picker
                  v-model="orderCameAtDate"
                  type="date"
                  format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd"
                  :picker-options="dealDisabledDate"
                  style="width: 140px;"
                  placeholder="日期"
                  @change="handleCameAtDate"
                >
                </el-date-picker>
                  -
                <el-time-picker
                  v-model="orderCameAtTime"
                  format="HH:mm:ss"
                  value-format="HH:mm:ss"
                  :picker-options="{selectableRange:`00:00:00-${endTime}`}"
                  style="width: 140px;"
                  placeholder="时间">
                </el-time-picker>
                <el-button type="text" :disabled="orderCameAt === '' || !orderCameAt" @click="getCarSizeItem({value: orderCameAt, key: 'cameAt'})">提交</el-button>
              </span>
                <span v-else>{{ orderData.cameAt }}</span>
              </p>
              <p>
                <span>出场时间：</span><span>{{ orderData.leftWaitAt }}</span>
              </p>
            </li>
            <li class="li-flex">
              <div v-if="chargeList['费用总额']"><span>费用总额：</span><span>{{ orderData.payableAmount3 }}</span><el-button type="text" @click="handleShowEnterAmount" v-if="orderData.cameAt === ''">编辑</el-button></div>
<!--              <div><span>车型：</span><span>{{ showCarSizeTable(orderData.carSize) }}</span></div>-->
              <div v-if="chargeList['优惠金额']"><span>优惠金额：</span><span>{{ orderData.couponMoney }}</span></div>
              <div v-if="chargeList['入场车道']"><span>入场车道：</span><span>{{ orderData.entranceName }}</span></div>
              <div v-if="chargeList['充电费用']"><span>充电费用：</span><span>{{ 0 }}</span></div>
              <div v-if="chargeList['分组钱包已付']"><span>分组钱包已付：</span><span>{{ orderData.companyPayMoney }}</span></div>
              <div v-if="chargeList['分组钱包余额']"><span>分组钱包余额：</span><span>{{ orderData.companyOrVehicleWallet }}</span></div>
              <div v-if="chargeList['电子已付']"><span>电子已付：</span><span>{{ orderData.moneyValuePaid }}</span></div>
              <div v-if="chargeList['出场车道']"><span>出场车道：</span><span>{{ orderData.exitName }}</span></div>
              <div v-if="chargeList['电子还需付']"><span>电子还需付：</span><span style="color: red;">{{ orderData.moneyValueToPay2 }}</span></div>
              <div v-if="chargeList['提示信息']"><span>提示信息：</span><span style="color: red;">{{ infoMsg }}</span></div>
              <div v-if="chargeList['预约抵扣费']"><span>预约抵扣费：</span><span>{{ 0 }}</span></div>
              <div v-if="chargeList['场内已付']"><span>场内已付：</span><span>{{ orderData.moneyValuePaid }}</span></div>
            </li>
            <li v-if="orderData.isBillPack === 1">
              <p><span>月卡开始时间：</span><span>{{ orderData.billPackList[0].billPackStartTime }}</span></p>
              <p><span>月卡结束时间：</span><span>{{ orderData.billPackList[0].billPackEndTime }}</span></p>
              <div class="billPackList-btn">
                <div>
                  <span>剩余天数：</span><span>{{ orderData.billPackDay }}</span>
                </div>
                <el-popover
                  placement="right"
                  width="260"
                  trigger="click">
                  <div v-for="(v, i) in orderData.billPackList" :key="i" style="margin-bottom: 10px;">
                    <p><span>月卡开始时间：</span><span>{{ v.billPackStartTime }}</span></p>
                    <p><span>月卡结束时间：</span><span>{{ v.billPackEndTime }}</span></p>
                  </div>
                  <el-button slot="reference" type="text">月卡详情</el-button>
                </el-popover>
              </div>
            </li>
            <li v-show="orderData.isBillPack !== 1 && Boolean(settingConfig.EditCarType)">
              <p style="display: block; text-align: left;">
                车型修改：<car-size-select ref="carSizeSelect" v-model="orderData.carSize" @change="getCarSizeItem"></car-size-select>
              </p>
            </li>
          </ul>
          <div class="pay-amount-item">
            <span>
              <div style="color: red;">¥:{{orderData.moneyValueToPay3}}</div>
              <div style="font-size: 14px; font-weight: normal; line-height: 1; text-align: center;">现金还需</div>
            </span>
          </div>
          <el-button type="" class="btn-code" @click="handleShowCode" :disabled="orderData.leftAt !== '' || orderData.isPaid" v-if="Boolean(settingConfig.ShowCodeGun)">
            <el-image :src="require('@/assets/img/codeIcond.png')" alt="" style="width: 20px;" v-if="orderData.leftAt !== '' || orderData.isPaid"></el-image>
            <el-image :src="require('@/assets/img/codeIcon.png')" alt="" style="width: 20px;" v-else></el-image>
            扫码支付
          </el-button>
          <div class="pay-btn-item" v-if="chargeButton['确认收费']">
            <el-button
              @click="confirmPay"
              class="confirm-btn"
              :disabled="freeTempOrderConfirm && (orderData.leftAt !== ''|| orderData.cameAt === '' || orderData.isPaid || orderData.moneyValueToPay3 === 0 || displayConfirmPay || clickDisabled.confirmPayType) || !freeTempOrderConfirm && (orderData.infoMsg === '已放行' || clickDisabled.confirmPayType)"
              type="primary"
            >确认{{freeTempOrderConfirm || !freeTempOrderConfirm && orderData.payableAmount3 > 0 && orderData.infoMsg === '已放行' || !freeTempOrderConfirm && orderData.moneyValueToPay3 > 0 ? '收费' : '开闸'}}<b v-if="type === '逐一' || type === '武汉'">(空格键)</b></el-button
            >
          </div>
          <div class="pay-btn-item" v-if="chargeButton['异常开闸']">
            <el-button
              @click="confirmOpenGate"
              class="btn-mini"
              style="padding: 12px 50px;"
              type="warning"
              :disabled="clickDisabled.confirmOpenGateType"
            >异常开闸<b v-if="!Boolean(settingConfig.ShowCodeGun)">(Enter键)</b></el-button>
          </div>
          <div class="pay-btn-item" v-if="chargeButton['免费开闸']">
            <el-button
              @click="freeOpen"
              class="confirm-btn"
              :disabled="freeTempOrderConfirm && (orderData.leftAt !== '' || orderData.isPaid || clickDisabled.freeOpenType) || !freeTempOrderConfirm && (orderData.infoMsg === '已放行' || clickDisabled.freeOpenType)"
              type="danger"
            >免费开闸</el-button>
          </div>
          <div class="pay-btn-item" v-if="chargeButton['直接开闸']">
            <el-button
              @click="justOpen"
              class="confirm-btn"
              style="width: 100%; margin-top: 10px;"
              :disabled="freeTempOrderConfirm && (orderData.id === -1 || !(orderData.cameAt !== '' && (orderData.moneyValueToPay2 === 0 || orderData.moneyValueToPay3 === 0)) || clickDisabled.justOpenType) || !freeTempOrderConfirm && (orderData.infoMsg === '无需支付' && orderData.moneyValueToPay3 === 0 || orderData.infoMsg === '等待支付' || clickDisabled.justOpenType) "
              type="success"
            >直接开闸</el-button>
          </div>
          <ul v-if="orderData.id !== -1">
            <li class="li-flex li-img">
              <el-image
                :src="orderData.passInFullImage"
                fit="contain"
                :preview-src-list="orderData.passInFullImageArr"
              >
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
                <div slot="error" class="image-slot">暂无图片</div>
              </el-image>
              <el-image
                :src="orderData.passOutFullImage"
                fit="contain"
                :preview-src-list="orderData.passOutFullImageArr"
              >
                <div slot="placeholder" class="image-slot">
                  加载中<span class="dot">...</span>
                </div>
                <div slot="error" class="image-slot">暂无图片</div>
              </el-image>
            </li>
          </ul>
        </template>
      </div>
    </rt-card>
    <el-dialog
      custom-class="real-dialog"
      :visible.sync="showPlateNum"
      width="30%"
      append-to-body
      center>
      <el-input class="dialog-plateNum" v-model="showDialogPlateNum" placeholder="请输入车牌号"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="getCarSizeItem({value: showDialogPlateNum, key: 'plateNumber'})">确 定</el-button>
        <el-button type="warning" @click="showPlateNum = false">取 消</el-button>
      </span>
    </el-dialog>
    <dialogDeductionVoucher
      title="折扣"
      :showdialog.sync="showDeductionVoucher"
    />
    <!-- <dialogGetInvoice title="开具发票" :showdialog.sync="showGetInvoice" /> -->
    <dialogHandleOutIn
      @getReason="confirmOpenGate"
      title="免费开闸"
      ref="mychild"
      :showdialog.sync="showHandleOutIn"
    />
    <dialog-pay-order-list
      ref="payOrderList"
      v-if="centerDialogVisible"
      :showdialog.sync="centerDialogVisible"
      @noOutGateId="showNoOutGateId"
    ></dialog-pay-order-list>
    <dialog-auth-code
      v-if="showAuthCode"
      :showdialog.sync="showAuthCode"
      :form="orderData"
    ></dialog-auth-code>
    <dialog-handle-table-out
      v-if="showHandleTableOut"
      :showdialog.sync="showHandleTableOut"
      @getOutGateId="confirmOutGate"
    ></dialog-handle-table-out>
    <dialog-enter-amount
      v-if="showEnterAmount"
      :showdialog.sync="showEnterAmount"
      @changeEnterAmount="getCarSizeItem"
    ></dialog-enter-amount>
  </div>
</template>

<script>
import rtCard from "@/serviceComponents/rtCard.vue";
import dialogDeductionVoucher from "@/serviceComponents/dialogDeductionVoucher";
// import dialogGetInvoice from "./dialogGetInvoice";
import dialogHandleOutIn from "@/serviceComponents/dialogHandleOutIn";
// import { orderPubSub, parkOutPubSub, settingPubSub, eventPubSub } from "@/service/pubsub/index";
import { orderPubSub, parkOutPubSub, eventPubSub } from "@/service/pubsub/index";
import { openGate, confirmOrderMoney } from "@/api/module/park";
import ParkLotMix from "@/minxs/parkLotId";
import showdialog from "@/minxs/showdialog";
import { getOrder, updateOrder, report } from "@/api/module/tenant";
// import gateSelect from "@/serviceComponents/gateSelect";
import { voicePrompt } from "@/utils/voicePrompt";
import dialogPayOrderList from "@/serviceComponents/dialogPayOrderList";
import dialogAuthCode from "@/serviceComponents/dialogAuthCode";
import carSizeSelect from "@/serviceComponents/carSizeSelect";
import dialogHandleTableOut from "@/serviceComponents/dialogHandleTableOut";
import { getChargingPopUp, getOutGateId, getIsSentryBoxTabs } from "@/utils/service";
import { distinguishTitle, newData } from "@/utils/index";
import dialogEnterAmount from "@/serviceComponents/dialogEnterAmount";
import { checkLeftGateTab } from "@/utils/wsMsg";

export default {
  components: {
    rtCard,
    dialogDeductionVoucher,
    // dialogGetInvoice,
    dialogHandleOutIn,
    // gateSelect,
    dialogPayOrderList,
    dialogAuthCode,
    carSizeSelect,
    dialogHandleTableOut,
    dialogEnterAmount,
  },
  mixins: [ParkLotMix, showdialog],
  data() {
    return {
      payForm: {},
      orderMoney: "6",
      realMoney: "6",
      showGetInvoice: false,
      showHandleOutIn: false,
      showDeductionVoucher: false,
      OutGateId: "",
      orderData: {
        id: -1,
        orderNo: "",
        parkingName: "",
        parkLotId: -1,
        parkSpotNumber: "",
        parkSpotId: 0,
        plateNumber: "",
        plateNumId: 0,
        plateColor: 1,
        parkStatus: "",
        status: 0,
        orderStatus: "正常",
        leftAt: "--",
        cameAt: "--",
        payableAmount: "0.00",
        moneyValueToPay: 0,
        moneyValuePaid: 0,
        payStatus: "--",
        paidAt: null,
        cashChannelId: 0,
        remark: "",
        parkingLength: "--",
        foreignFrom: "",
        parkPassingInId: -1,
        parkPassingOutId: -1,
        entranceName: "--",
        exitName: "--",
        isBillPack: 2,
        carSize: 0,
        carType: "--",
        couponMoney: 0,
        createdAt: "--",
        passType: 1,
      },
      show: false,
      loading: false,
      titleObj: {},
      showPaySuccess: false,
      showPayError: false,
      infoMsg: '',
      orderCameAtDate: '',
      orderCameAtTime: '',
      endTime: '',
      centerDialogVisible: false,
      showAuthCode: false,
      AuthCode: undefined,
      // leftGateTabStr: undefined,
      showPlateNum: false,
      showDialogPlateNum: undefined,
      displayConfirmPay: false,
      showHandleTableOut: false,
      type: null,
      showEnterAmount: false,
      clickDisabled: {
        confirmPayType: false,
        confirmOpenGateType: false,
        freeOpenType: false,
        justOpenType: false,
      },
      freeTempOrderConfirm: undefined,
    };
  },
  watch: {
    GateId: function (newV) {
      this.OutGateId = newV;
      // this.$refs.tabSelect.gateId = String(newV);
    },
    isShowOrderDetail: function (newV) {
      if (!newV) {
        this.resetOrder();
        this.show = false;
        this.titleObj = {};
        this.$store.dispatch("SetLiveImages", JSON.stringify({}));
      }
    },
    wsOrderArrStr: {
      handler(newValue){
        // checkLeftGateTab(this, JSON.parse(val), this.leftGateTab);
        let arr = JSON.parse(newValue);
        if (this.settingConfig.ChargeBullet === 0
          && arr.length === 0) {
          setTimeout(() => {
            this.$store.dispatch("GetShowOrderDetail", false);
          }, 2000)
        }
        this.$forceUpdate();
      },
      deep:true
    },
    gateIds: function() {
      // this.$store.dispatch("SetLeftGateIdTabs", '[]');
      // this.$store.dispatch("SetPayOrderGateId", undefined);
      // removeOutGateId();
      // console.log(this.$store.state.order.payOrderGateId)
      if (this.isSentryBoxManager) {
        checkLeftGateTab(JSON.parse(this.wsOrderArrStr), this.leftGateTab);
        this.$forceUpdate();
      } else {
        checkLeftGateTab([], this.leftGateTab);
        this.$forceUpdate();
      }
    },
  },
  computed: {
    direction: function () {
      return this.$route.params.Direction ? this.$route.params.Direction : "";
    },
    isShowOrderDetail: function () {
      return this.$store.state.order.showOrderDetail;
    },
    GateId: function () {
      // let arr = this.$store.state.order.gateIds
      //   ? this.$store.state.order.gateIds
      //   : [];
      // let leftArr = arr.filter((item) => {
      //   return Number(item.Direction) === 2;
      // });
      // let id = leftArr[0] ? leftArr[0].Id : undefined;
      return this.$store.state.order.pubOutGateId;
    },
    wsOrderArr: function () {
      return this.$store.state.order.moreWsData[this.$store.state.order.moreWsData.lastKey];
    },
    wsOrderArrStr: function() {
      return this.$store.state.order.wsOrderArrStr
    },
    leftGateTab: {
      get() {
        return JSON.parse(this.$store.state.order.leftGateIdTabs);
      },
    },
    settingConfig: function () {
      return JSON.stringify(this.$store.state.layout.settingConfig) === '{}' ? JSON.parse(getChargingPopUp()) : this.$store.state.layout.settingConfig;
    },
    chargeList: function () {
      let obj = {};
      this.settingConfig.ChargeList.length > 0 && this.settingConfig.ChargeList.forEach(v => {
        obj[v] = true
      });
      return obj
    },
    chargeButton: function() {
      let obj = {};
      this.settingConfig.ChargeButton.length > 0 && this.settingConfig.ChargeButton.forEach(v => {
        obj[v] = true
      });
      return obj
    },
    orderCameAt: function () {
      if(this.orderCameAtDate === '' || !this.orderCameAtDate || this.orderCameAtTime === '' || !this.orderCameAtTime) {
        return ''
      } else {
        return this.orderCameAtDate + ' ' + this.orderCameAtTime
      }
    },
    leftGateTabStr: function () {
      return this.$store.state.order.leftGateIdTabs
    },
    dealDisabledDate() {
      return {
        disabledDate: time => (time.getTime() > new Date(this.orderData.leftWaitAt).getTime()),
      }
    },
    moreWsData: function () {
      return this.$store.state.order.moreWsData;
    },
    isSentryBoxManager : function () {
      return this.$store.state.layout.isSentryBoxTabs ? this.$store.state.layout.isSentryBoxTabs === 'true' : getIsSentryBoxTabs() === 'true';
    },
    gateIds: function () {
      return this.$store.state.order.gateIdsStr
    }
  },
  mounted() {
    this.type = distinguishTitle();
    const that = this;
    orderPubSub.unsubscribe();
    orderPubSub.subscribe(this.getOrder);
    if (this.GateId) {
      this.OutGateId = this.GateId;
      // this.$refs.item.server(true);
    }
    this.displayConfirmPay = false;
    this.freeTempOrderConfirm = sessionStorage.getItem('FreeTempOrderConfirm') !== '2';
    document.onkeyup = function (e) {
      // console.log('showOrderDetail',that.isShowOrderDetail)
      // console.log('showHandleOutIn',that.showHandleOutIn)
      if (e.keyCode == 32 && that.isShowOrderDetail && !that.showHandleOutIn && !that.showAuthCode && that.chargeButton['确认收费']) {
        window.event.preventDefault(); //关闭浏览器快捷键
        let btnBool = that.freeTempOrderConfirm && (that.orderData.leftAt !== ''|| that.orderData.cameAt === '' || that.orderData.isPaid || that.orderData.moneyValueToPay3 === 0 || that.displayConfirmPay || that.clickDisabled.confirmPayType) || !that.freeTempOrderConfirm && (that.orderData.infoMsg === '已放行' || that.clickDisabled.confirmPayType);
        if ((that.type === '逐一' || that.type === '武汉') && !btnBool) that.confirmPay();
        // if (!btnBool) that.confirmPay();
      } else if (e.keyCode == 13 && that.isShowOrderDetail && !that.showHandleOutIn && !that.showAuthCode && !that.settingConfig.ShowCodeGun && that.chargeButton['异常开闸'] && !that.clickDisabled.confirmOpenGateType) {
        // 异常开闸
        window.event.preventDefault();
        that.confirmOpenGate();
      } else if (
        e.keyCode == 32 &&
        that.isShowOrderDetail &&
        that.showHandleOutIn
      ) {
        window.event.preventDefault(); //关闭浏览器快捷键
        that.clickParent();
      }
    };
    // settingPubSub.subscribe(this.getSetting);
    if (this.GateId=== '' && this.leftGateTabStr.length > 0) {
      let leftArr = JSON.parse(this.leftGateTabStr);
      this.$store.dispatch("SetPayOrderGateId", !getOutGateId() ? leftArr[0].Id : parseInt(getOutGateId()));
    }
  },
  methods: {
    // 获取订单
    getOrder(data) {
      // console.log('getOrder', data);
      this.show = true;
      this.loading = true;
      try {
        if (data && data.InfoMsg) {
          this.infoMsg = data.InfoMsg;
        }
        if (data && data.otherMsg) {
          this.OutGateId = Number(data.park_lot_gate_id);
          this.$store.dispatch("SetTabsGateId", data.park_lot_gate_id);
          // this.orderData = JSON.parse(data.otherMsg);
          // console.log('参数',this.orderData)
          let obj = JSON.parse(data.otherMsg);
          obj.isPaid = data.isPaid;
          obj.messageType = data.message_type;
          this.fillOrderCard(obj);
          this.loading = false;
        } else {
          let id = data.id ? Number(data.id) : Number(data.Id);
          if (data.park_lot_gate_id) {
            this.OutGateId = data.park_lot_gate_id;
            this.$store.dispatch("SetTabsGateId", data.park_lot_gate_id);
          }
          // id = 111658273;
          if (id === -1) {
            this.show = true;
            this.loading = false;
            this.OutGateId = this.$store.state.order.payOrderGateId ? this.$store.state.order.payOrderGateId : this.GateId;
            this.$store.dispatch("SetTabsGateId", this.OutGateId);
            this.$store.dispatch("SetPayOrderGateId", this.OutGateId);
            this.resetOrder();
          } else {
            this.$store.dispatch("SetTabsGateId", data.park_lot_gate_id);
            getOrder({ Id: Number(id) }).then((res) => {
              this.loading = false;
              if (res.state === "success") {
                res.data.isPaid = data.isPaid;
                res.data.messageType = data.message_type;
                if (this.isSentryBoxManager) this.checkMoreWsData(res.data);
                this.fillOrderCard(res.data);
              } else {
                this.orderData = {}
              }
            });
          }
        }
      } catch (error) {
        console.log("err", error);
      }
    },
    // 确认收费
    async confirmPay() {
      this.displayConfirmPay = true;
      this.clickDisabledFun('confirmPayType');
      if (!this.OutGateId) {
        return this.$message({
          message: "请选择道闸",
          type: "error",
        });
      }
      let res = await confirmOrderMoney({
        Id: this.orderData.id,
        OutGateId: Number(this.OutGateId),
        MoneyValuePaid: this.orderData.moneyValueToPay3 * 1,
        PlateNumber: this.orderData.plateNumber,
        Source: 2,
      });
      if (res.state === "success") {
        this.$message.success("操作成功");
        setTimeout(() => {
          parkOutPubSub.publish();
        }, 10000);
        voicePrompt("一路平安");
        this.displayConfirmPay = false;
      } else {
        this.$message({ message: res.message, type: "error" });
        this.displayConfirmPay = false;
      }
    },
    // 确认开闸
    async confirmOpenGate(str) {
      this.clickDisabledFun('confirmOpenGateType');
      openGate({
        id: this.orderData.id,
        reason: str,
        ParkLotId: this.$store.state.order.parkLotId,
        outGateId: Number(this.OutGateId),
        Source: 2,
        AbnormalType: typeof(str) === 'object' ? 2 : 11,
      }).then((res) => {
        if (res.state === "success") {
          voicePrompt("一路平安");
        } else {
          this.$message({ message: res.message, type: "error" });
        }
      });
    },
    // 免费开闸
    freeOpen() {
      this.clickDisabledFun('freeOpenType');
      if (this.orderData.plateNumber.length === 0) {
        return this.$message.error("请先选择出口车道");
      }
      this.showHandleOutIn = true;
    },
    clickParent() {
      this.$refs.mychild.handleClick();
    },
    cancel() {
      this.$store.dispatch("GetShowOrderDetail", false);
    },
    openNotify() {
      this.$notify({
        title: '扣款成功',
        dangerouslyUseHTMLString: true,
        message: '<div>支付流水号：288779956240095496</div><div>已付款：3元</div>',
        type: 'success',
        duration: 0
      });
    },
    tabChange(data) {
      this.OutGateId = data.Id;
      this.$store.dispatch("SetTabsGateId", String(data.Id));
      this.$store.dispatch("SetPayOrderGateId", data.Id);
      // this.$refs.tabSelect.gateId = String(this.OutGateId);
      // console.log('tabChange', this.OutGateId)
      if (data.orderId){
        this.getOrder({id: data.orderId, park_lot_gate_id: String(data.Id)})
      } else {
        this.resetOrder()
      }
    },
    fillOrderCard(data) {
      // console.log(data)
      this.orderData = data;
      this.orderData.passInFullImageArr = [data.passInFullImage];
      this.orderData.passOutFullImageArr = [data.passOutFullImage];
      // this.orderData.cameAt = '';
      if (this.orderData.cameAt === '') {
        let date = new Date(this.orderData.leftWaitAt);
        this.orderCameAtDate = this.formatDate(date);
        this.endTime = this.formatTime(date);
        this.orderCameAtTime = this.formatTime(new Date(date.setTime(date.getTime()-20*60*1000)));
        // console.log(this.endTime, this.orderCameAtDate);
      }
      if (!this.orderData.billPackList && this.orderData.carTypeStr === '月卡车') {
        this.orderData.billPackList = [{billPackStartTime: '--', billPackEndTime: '--'}]
      }
      this.infoMsg = data.infoMsg;
      // console.log('fillOrderCard', this.orderData.id)

      let {passInFullImageArr, passOutFullImageArr, outGateId, inGateId} = this.orderData;
      this.$store.dispatch("SetLiveImages", JSON.stringify({passInFullImageArr, passOutFullImageArr, outGateId, inGateId}));

      this.show = true;
      this.$nextTick(() => {
        let typeIndex = Math.ceil(Math.random()*5);
        this.titleObj = {value: this.orderData.carTypeStr, type: this.titleType[typeIndex-1]};
        setTimeout(() => {
          if(this.orderData.isBillPack !== 1 && Boolean(this.settingConfig.EditCarType))this.$refs.carSizeSelect.server(true);
        }, 300)
        if (this.orderData.payableAmount * 1 > 0) {
          voicePrompt(
            `${this.orderData.plateNumber}出场，请扫码缴费${this.orderData.payableAmount}元`
          );
        } else {
          voicePrompt("一路平安");
        }
        if(this.orderData.errorMsg !== ''){
          this.$notify({
            title: '扣款失败',
            dangerouslyUseHTMLString: true,
            message:`<div>${this.orderData.errorMsg}</div>`,
            type: 'error',
          });
        }
      })
    },
    async getCarSizeItem(obj) {
      // console.log('getCarSizeItem', obj, this.orderData);
      let param = {
        id: this.orderData.id,
        payableAmount: Number(this.orderData.payableAmount),
        moneyValuePaid: Number(this.orderData.moneyValuePaid),
        status: this.orderData.status,
        plateColor: this.orderData.plateColor,
        plateNumber: this.orderData.plateNumber,
        carSize: this.orderData.carSize,
        Source: 2,
        LoginPlatform: 'gate',
      };
      param[obj.key] = obj.value;
      if (obj.key === 'payableAmount') {
        let date = new Date(new Date().getTime() - 20 * 60 * 1000);
        param.cameAt = newData(date)
      }
      // console.log(param);
      let res = await updateOrder(param);
      if (res.state === "success") {
        if(obj.key === 'plateNumber') this.showPlateNum = false;
        if(obj.key === 'cameAt') this.orderCameAt = '';
        this.getOrder({id: this.orderData.id});
        eventPubSub.publish("");
      } else {
        this.$message.error(res.message);
      }
    },
    justOpen() {
      this.clickDisabledFun('justOpenType');
      openGate({
        outGateId: Number(this.OutGateId),
        AbnormalType: 10,
        Source: 2,
      }).then((res) => {
        if (res.state === "success") {
          voicePrompt("一路平安");
        } else {
          this.$message({ message: res.message, type: "error" });
        }
      });
    },
    handleShowList() {
      // this.showHandleTableOut = true;
      if (!this.OutGateId || this.OutGateId === 0 || this.OutGateId === '' || !this.$store.state.order.payOrderGateId) {
        this.showHandleTableOut = true;
      } else {
        this.clickSimilarList();
      }
    },
    clickSimilarList() {
      this.centerDialogVisible = true;
      this.$store.dispatch("SetShowPayOrderList", true);
      this.$nextTick(() => {
        // console.log('clickSimilarList', this.OutGateId)
        this.$refs.payOrderList.centerDialogPlateNum = this.orderData.plateNumber;
        this.$refs.payOrderList.ParkingDiffPlateCharNum = 0;
        this.$refs.payOrderList.OutGateId = this.OutGateId;
        this.$refs.payOrderList.queryList();
      })
    },
    handleShowCode() {
      this.showAuthCode = true;
      this.$store.dispatch("SetShowAuthCode", true);
    },
    resetOrder() {
      this.orderData = {
        id: -1,
        plateNumber: undefined,
        parkingLength: '--',
        cameAt: '--',
        leftAt: '--',
        payableAmount3: '--',
        carSize: '--',
        companyPayMoney: '--',
        moneyValuePaid: '--',
        moneyValueToPay2: '--',
        moneyValueToPay3: '--',
      };
      this.infoMsg = '--';
    },
    handleReport() {
      report({Id: this.orderData.id});
    },
    handleShowPlateNum(plateNumber) {
      this.showDialogPlateNum = plateNumber;
      this.showPlateNum = true;
    },
    confirmOutGate(str) {
      this.OutGateId = parseInt(str);
      this.$store.dispatch("SetTabsGateId", String(str));
      this.$store.dispatch("SetPayOrderGateId", this.OutGateId);
      this.clickSimilarList();
    },
    handleShowEnterAmount() {
      this.showEnterAmount = true
    },
    clickDisabledFun(label) {
      for(let key in this.clickDisabled) {
        if (key !== label) this.clickDisabled[key] = true
      }
      setTimeout(() => {
        for(let key in this.clickDisabled) {
          this.clickDisabled[key] = false
        }
      }, 5000)
    },
    checkMoreWsData(data) {
      this.moreWsData[sessionStorage.getItem('sentryId')].forEach(v => {
        if (v.Id === String(data.id)) {
          v.otherMsg = JSON.stringify(data);
          v.change = 1;
          this.$store.dispatch("SETMoreWsData", {obj: v, SentryBoxId: sessionStorage.getItem('sentryId'), key: 'moreWsData'});
        }
      })
    },
    showNoOutGateId() {
      this.showHandleTableOut = true;
    },
    handleCameAtDate() {
      let date = new Date(this.orderData.leftWaitAt.slice(0, 10));
      let dateChange = new Date(this.orderCameAtDate);
      if (dateChange.getTime() < date.getTime()) {
        this.endTime = '23:59:59';
      } else {
        this.endTime = this.formatTime(date);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
<style lang="scss">
  .pay-order-btn-group{
    text-align: left;
    /*margin-top: 20px;*/
    margin-bottom: 20px;
  }
  .rt-card{
    .rt-card-header{
      padding: 0!important;
    }
  }
</style>
